<template>
  <q-list bordered class="rounded-borders" style="max-width: 350px">
    <q-item-label header class="q-pb-none">Subject areas</q-item-label>
    <q-item>
      <q-item-section>
        <q-item-label v-for="subject of article.subject_areas" :key="subject.id" class="text-subtitle2">
          {{ subject.name }} - {{ subject.code }}
        </q-item-label>
      </q-item-section>
    </q-item>
  </q-list>
</template>

<script>
export default {
  props: {
    article: Object
  }
}
</script>
